<template>
  <div class="pic-card">
    <div class="pic">
      <img :src="card.picture" />
    </div>
    <div class="txt">
      <h4>{{ card.title }}</h4>
      <p>{{ card.type }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cards: {
      type: Object,
      default: () => ({
        picture: 'https://picsum.photos/300/200?random=11',
        title: '露天農田',
        type: '農民服務',
      }),
    },
  },
  data() {
    return {
      card: this.cards,
    };
  },
};
</script>

<style scoped lang="scss">
.pic-card {
  max-width: 500px;
  color: #212529;
  background-color: #fff;
  border: solid 1px #fff;
  margin: 2px;
  .pic {
    margin-bottom: 10px;
    img {
      width: 100%;
      object-fit: cover;
      height: 250px;
    }
  }
  .txt {
    h4 {
      margin-bottom: 10px;
    }
    p {
      color: rgb(172, 170, 170);
      margin-bottom: 10px;
    }
  }
}
</style>
